<template>
  <div class="footer_page" >
    <div class="w1200 mar_auto">
      <div class="flex_box">
        <img src="../assets/images/footer_logo.png" class="logo_size" alt="" />
        <div class="item ov">
          <div class="">上海展 展会时间：2027年5月12日-14日</div>
          <div class="mt5">上海展 展会地点：上海新国际博览中心（上海市浦东新区龙阳路2345号）</div>

          <div class="mt12">杭州展 展会时间：2027年9月9日-11日</div>
          <div class="mt5">杭州展 展会地点：杭州国际博览中心（杭州市萧山区钱江世纪城奔竞大道353号）</div>

         

        </div>
        <div class="w320">
          <div class="">观众参观如有疑问请联系：Vicky Shi 石女士</div>
          <div class="mt12 df aic"><img src="../assets/images/icon_call.png" class="icon_call" alt="" /><span>+86 (21) 23263688</span></div>
          <div class="mt12 df aic"><img src="../assets/images/icon_email.png" class="icon_email" alt="" /><span>Visitors@ChinaBeautyExpo.com</span></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {

  },
  data() {
    return {

    }
  }
}
</script>

<style scoped lang="less">
.footer_page {
  position: relative;
  display: block;
  width: 100%;
  height: 160px;
  padding-top: 32px;
  margin-top: 50px;
  margin-bottom: 0;
  font-size: 16px;
  line-height: 24px;
  color: #fff;
  background: #A90000;
  z-index: 6;
  
  // 开发环境修复
  @media screen {
    &:not(.production) {
      margin-top: -20px;
    }
  }
  
  .logo_size {
    position: relative;
    width: 260px;
    height: 60px;
    margin-right: 20px;
    margin-top: 20px;
  }
  .icon_call,.icon_email {
    width: 16px;
    height: 16px;
    margin-right: 8px;
  }
}
</style>
